<template>
    <u-btn-icon-outlined-tile v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-icon-outlined-tile>
</template>

<script>
import UBtnIconOutlinedTile from "@/components/publish/styles/buttons/u-btn-icon-outlined-tile.vue";

export default {
    props: {},
    components: {
        UBtnIconOutlinedTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
